import { render } from "./RemoveFileDialog.vue?vue&type=template&id=3fefc814&scoped=true"
import script from "./RemoveFileDialog.vue?vue&type=script&lang=js"
export * from "./RemoveFileDialog.vue?vue&type=script&lang=js"

import "./RemoveFileDialog.vue?vue&type=style&index=0&id=3fefc814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fefc814"]])

export default __exports__